import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Trophy, Medal, Award } from "lucide-react";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then(r => setRows(r.data)); }, []);
  if (rows.length === 0) return null;
  const podium = rows.slice(0, 3);
  const rest = rows.slice(3);
  const rankIcon = (i) => i === 0 ? <Trophy size={14} className="text-amber-500"/> : i === 1 ? <Medal size={14} className="text-slate-400"/> : <Award size={14} className="text-amber-700"/>;
  return (
    <Card className="p-6" data-testid="leaderboard-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Team Leaderboard</div>
          <div className="text-xs text-muted-foreground mt-1">Score = bookings×10 + visits×3 + calls×1</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
        {podium.map((r, i) => (
          <div key={r.id} className={`p-4 rounded-lg border ${i === 0 ? "bg-accent/10 border-accent/40" : "bg-secondary/40 border-border"}`} data-testid={`podium-${i+1}`}>
            <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-muted-foreground">
              {rankIcon(i)} Rank {i+1}
            </div>
            <div className="font-serif-display text-xl mt-1">{r.name}</div>
            <div className="text-xs text-muted-foreground capitalize">{r.role?.replace(/_/g," ")} · {r.division}</div>
            <div className="mt-3 flex gap-4 text-xs">
              <div><span className="text-muted-foreground">Score</span> <span className="metric-value">{r.score}</span></div>
              <div><span className="text-muted-foreground">Bookings</span> <span className="metric-value">{r.bookings}</span></div>
              <div><span className="text-muted-foreground">Visits</span> <span className="metric-value">{r.visits}</span></div>
            </div>
          </div>
        ))}
      </div>
      {rest.length > 0 && (
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="text-left py-2">#</th><th className="text-left py-2">Name</th><th className="text-left py-2">Role</th><th className="text-right py-2">Bookings</th><th className="text-right py-2">Visits</th><th className="text-right py-2">Calls</th><th className="text-right py-2">Score</th></tr>
          </thead>
          <tbody>
            {rest.map(r => (
              <tr key={r.id} className="border-t border-border">
                <td className="py-2 text-xs text-muted-foreground">{r.rank}</td>
                <td className="py-2">{r.name}</td>
                <td className="py-2 text-xs capitalize">{r.role?.replace(/_/g," ")}</td>
                <td className="py-2 text-right metric-value">{r.bookings}</td>
                <td className="py-2 text-right metric-value">{r.visits}</td>
                <td className="py-2 text-right metric-value">{r.calls}</td>
                <td className="py-2 text-right metric-value">{r.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}
